import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ServicesPage from '@/pages/services/page';
import ServiceDetailPage from '@/pages/service-detail/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/:serviceId',
    element: <ServiceDetailPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
